import { AxiosInstance, AxiosError } from 'axios'

import { AxiosErrorResponseData } from '@marketplace-web/core-api/api-client-util'

import { DD_RESPONSE_DISPLAYED_EVENT } from '../constants/events'
import { isAxiosErrorBlockedByDataDome } from '../utils/utils'
import {
  incrementDataDomeRequestBlocked,
  incrementDataDomeScriptMissing,
} from '../utils/observability'

const SCRIPT_FAILS_TO_TRIGGER_TIMEOUT = 3000

const handleDataDomeCaptchaFailedToRender = (eventAbortController: AbortController) => {
  incrementDataDomeScriptMissing()

  eventAbortController.abort()
}

const handleDataDomeCaptchaRendered = (timeoutId: NodeJS.Timeout) => {
  clearTimeout(timeoutId)
}

export const missingDataDomeScriptDetectionInterceptor = (instance: AxiosInstance) => {
  instance.interceptors.response.use(
    undefined,
    (error: AxiosError<AxiosErrorResponseData<unknown>>) => {
      if (
        error.response &&
        isAxiosErrorBlockedByDataDome(error.response.headers, error.response.data)
      ) {
        incrementDataDomeRequestBlocked()

        const eventAbortController = new AbortController()

        const timeoutId = setTimeout(() => {
          handleDataDomeCaptchaFailedToRender(eventAbortController)
        }, SCRIPT_FAILS_TO_TRIGGER_TIMEOUT)

        window.addEventListener(
          DD_RESPONSE_DISPLAYED_EVENT,
          () => handleDataDomeCaptchaRendered(timeoutId),
          {
            signal: eventAbortController.signal,
            once: true,
          },
        )
      }

      return Promise.reject(error)
    },
  )
}
